import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import SignIn from '../SignIn/SignIn';
import ShoppingCartIcon from './img/cart.png';
import './NavigationBar.scss';

export interface INavigationBarProps {}

const NavigationBar: React.FunctionComponent<INavigationBarProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="navigationBar">
      <div className="navBar">
        <div className={`nav-items ${isOpen && 'open'}`}>
          <NavLink to="/" className={'menu-item burger'}>
            ГОЛОВНА
          </NavLink>

          <NavLink to="/checkout" className={'menu-item burger'}>
            НОВИНКИ
          </NavLink>

          <NavLink to="/categories" className={'menu-item burger'}>
            КАТЕГОРІЇ
          </NavLink>
        </div>
        <div className={`nav-toggle ${isOpen && 'open'}`} onClick={() => setIsOpen(!isOpen)}>
          <div className="bar"></div>
        </div>
      </div>
      <div className="right">
        <form name="search ">
          <input type="text" className="search" name="txt" placeholder="Я шукаю..." />
        </form>
        <div className="right">
          <SignIn />
        </div>
        <div className="right">
          <NavLink to="/cart">
            <img className="cart" aria-label="cart" src={ShoppingCartIcon}></img>
          </NavLink>
        </div>
        {/* </NavLink> */}
      </div>
    </div>
  );
};

export { NavigationBar };
